import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Economy next on the noobs' list of things to ruin?",
  "description": "",
  "published": "2011-10-15T00:00:00.000Z",
  "redirect_from": ["/blog/economy-next-on-the-noobs-list-of-things-to-ruin/swizec/2634"],
  "categories": "Arts and Entertainment, Lowest common denominator, Monty Python, Newbie, Uncategorized",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2011/10/300px-Beastie_Boys_Sonar_2007_Barcelona_Catalonia.jpg",
        "alt": "Actuació de Beastie Boys al Sónar 2007.",
        "title": "Actuació de Beastie Boys al Sónar 2007."
      }}></img></p>
    <p>{`Today is worldwide Occupy Whatever Is Near You day - a spinoff of the Occupy `}<a parentName="p" {...{
        "href": "http://maps.google.com/maps?ll=40.7063888889,-74.0094444444&spn=0.01,0.01&q=40.7063888889,-74.0094444444%20(Wall%20Street)&t=h",
        "title": "Wall Street"
      }}>{`Wall Street`}</a>{` movement that's currently popular with `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Hoi_polloi",
        "title": "Hoi polloi"
      }}>{`the hoi polloi`}</a>{`. Remember how a few years ago we had to kill all the muslims?`}</p>
    <p>{`I went to see the protesters today and I have to say the whole thing seems rather strange.`}</p>
    <p>{`First of all, they were marching behind a very popular song `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/%28You_Gotta%29_Fight_for_Your_Right_%28To_Party%21%29",
        "title": "(You Gotta) Fight for Your Right (To Party!)"
      }}>{`Fight For Your Right`}</a>{` by the `}<a parentName="p" {...{
        "href": "http://www.beastieboys.com",
        "title": "Beastie Boys"
      }}>{`Beastie Boys`}</a>{`, which undoubtedly brought millions if not billions of pure profits to the license holders ... most likely a huge record label.`}</p>
    <p>{`Most of the protesters were also taking photos with their iphones, wearing clothes made affordable by cheap production in `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Sweatshop",
        "title": "Sweatshop"
      }}>{`sweat shops`}</a>{` of China and using twitter and facebook to communicate ... you know two very capitalistically inclined startups.`}</p>
    <p>{`How much is facebook worth again?`}</p>
    <p>{`Oh and they were using roads made possible by a long history of "exploitation". The whole thing reminds me a lot of this particular `}<a parentName="p" {...{
        "href": "http://www.pythonline.com/",
        "title": "Monty Python"
      }}>{`Monty Python`}</a>{` skit:`}</p>
    <lite-youtube {...{
      "videoid": "ExWfh6sGyso",
      "videostartat": "0"
    }}></lite-youtube>
    <p>{`Actually, there's another relevant video you should watch. It's about how The Noob Effect has ruined videogames. Mostly it speaks how pandering to the `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Lowest_common_denominator",
        "title": "Lowest common denominator"
      }}>{`lowest common denominator`}</a>{` will eventually ruin everything.`}</p>
    <lite-youtube {...{
      "videoid": "n7VAhzPcZ-s",
      "videostartat": "0"
    }}></lite-youtube>
    <p>{`I think this is what the ribble rabble are trying to do right now. They want the economy as a whole to pander to the lowest common denominator - a social sciences graduate with no skills beyond serving tables at the local coffee shop.`}</p>
    <p>{`The Noob Effect has already happened to our videogames, movies, music, blogs, literature ... hell, even food and education. How about we not let the same happen to, you know, `}<em parentName="p">{`the fucking core of our freaking society?`}</em></p>
    <p>{`Just play the damn game and stop trying to ruin it for everybody else!`}</p>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=65c7a642-d754-4b12-b0f1-ce8c16873baf",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      